import React, { ReactElement } from "react";
import { SimplifiedAgencies } from "../../../messages/Agency";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { TORSOS_SVG } from "../../../utils/svgs";
import { AppBottomSheet } from "../../Generic/AppBottomSheet";
import { AppButton } from "../../Generic/AppButton";
import { AppIcon } from "../../Generic/AppIcon";
import { If } from "../../Generic/If";

interface Props {
  isOpen: boolean;
  agency: SimplifiedAgencies;
  onClickYes: () => void;
  onClickNo?: () => void;
  onRequestClose: () => void;
}

export function RequestAgencyBottomSheet(props: Props): ReactElement {
  const logoUrl = props.agency.logoUrl !== null ? `url("${props.agency.logoUrl}")` : undefined;

  const onClickYes = React.useCallback(() => {
    props.onRequestClose.call(null);
    props.onClickYes.call(null);
  }, [props.onRequestClose, props.onClickYes]);

  const onClickNo = React.useCallback(() => {
    props.onRequestClose.call(null);

    if (props.onClickNo !== undefined) {
      props.onClickNo.call(null);
    }
  }, [props.onRequestClose, props.onClickNo]);

  return (
    <AppBottomSheet
      isOpen={props.isOpen}
      className="RequestAgencyBottomSheet"
      rounded={true}
      onRequestClose={props.onRequestClose}
    >
      <h5>{translate(STRINGS.REQUEST_AGENCY)}?</h5>
      <div className="RequestAgencyBottomSheet__Logo" style={{ backgroundImage: logoUrl }}>
        <If condition={logoUrl === undefined}>
          <AppIcon icon={TORSOS_SVG} fill="blue-gray" />
        </If>
      </div>
      <div className="RequestAgencyBottomSheet__AgencyName">{props.agency.name}</div>
      <div className="RequestAgencyBottomSheet__Buttons">
        <AppButton onClick={onClickYes}>{translate(STRINGS.YES)}</AppButton>

        <AppButton variant="outline" onClick={onClickNo}>
          {translate(STRINGS.NO)}
        </AppButton>
      </div>
    </AppBottomSheet>
  );
}
